import React from "react";
import { Stack, Typography, useTheme } from "@mui/material";
import WalletIcon from "../img/Wallet.svg";
import ColoredIcon from "./ColoredIcon";
import { formatPrice } from "../utils/priceFormatter";

interface Props {
    price: number; // in cents
    currency?: string;
    discount?: number; // percent, e.g., 20
    iconSize?: string;
    fontSize?: string;
    lineHeight?: string;
    textColor?: "black" | "white" | "brand";
}

const FormattedPrice = ({
    price,
    currency = "EUR",
    discount = 0,
    iconSize = "16px",
    fontSize = "15px",
    lineHeight = "22px",
    textColor = "black",
}: Props) => {
    const theme = useTheme();
    const color =
        textColor === "brand" ? theme.palette.primary.main : textColor;

    const hasDiscount = discount > 0;
    const discountedPrice = Math.round(price * (1 - discount / 100));

    return (
        <Stack
            className="no-translation"
            translate="no"
            direction="row"
            alignItems="center"
            spacing={0.5}
        >
            <ColoredIcon
                icon={WalletIcon}
                color={color}
                size={iconSize}
                style={{ opacity: "50%" }}
            />
            {hasDiscount ? (
                <>
                    <Typography
                        className="no-translation"
                        translate="no"
                        fontWeight={700}
                        fontSize="15px"
                        lineHeight={lineHeight}
                        color={color}
                        sx={{
                            textDecoration: "line-through",
                            opacity: 0.7,
                            whiteSpace: "nowrap",
                        }}
                    >
                        {formatPrice(price, currency)}
                    </Typography>
                    <Typography
                        className="no-translation"
                        translate="no"
                        fontWeight={700}
                        fontSize={fontSize}
                        lineHeight={lineHeight}
                        color={color}
                        sx={{ whiteSpace: "nowrap" }}
                    >
                        {formatPrice(discountedPrice, currency)}
                    </Typography>
                    <Typography
                        fontWeight={600}
                        fontSize="13px"
                        lineHeight="18px"
                        color="#ffe082"
                        bgcolor="#d32f2f"
                        paddingX={1}
                        paddingY={0.25}
                        borderRadius="6px"
                        alignSelf="flex-start"
                    >
                        -{discount}%
                    </Typography>
                </>
            ) : (
                <Typography
                    className="no-translation"
                    translate="no"
                    fontWeight={700}
                    fontSize={fontSize}
                    lineHeight={lineHeight}
                    color={color}
                    sx={{ whiteSpace: "nowrap" }}
                >
                    {formatPrice(price, currency)}
                </Typography>
            )}
        </Stack>
    );
};

export default FormattedPrice;
